// The colours of the dashboard's charts. Blue then orange are the first two of the validated categorical palette (both pass the colour-vision
// and lightness checks against the app's white surface; run `validate_palette.js "#2a78d6,#eb6834" --mode light --surface "#ffffff"`).
// A series keeps its colour wherever it appears, whatever else is on the chart. The app has no dark mode, so there is one set.
export const FIRST = '#2a78d6';
export const SECOND = '#eb6834';

// Text, grid and axes are not series: they recede.
export const SURFACE = '#ffffff';
export const INK = '#253B36';
export const INK_SECONDARY = '#5F706A';
export const GRID = '#E3E8E2';
